import $ from "jquery";
import { GraphForm } from "./graph_form";
import { ConditionPanel } from "./condition_panel";
import { ItemAspect } from "./item_aspect";

// Interface definitions
interface InvalidParameterCombination {
  type?: string;
  partition?: string;
  hasDimension?: boolean;
}

class CookRankingsView {
  private conditionPanel: ConditionPanel;
  private itemAspect: ItemAspect;

  constructor() {
    // FIXME: do not expose formElement to the view; its controller matter.
    this.conditionPanel = new ConditionPanel($("#rankings_form"));
    this.itemAspect = new ItemAspect();
  }

  initialize(
    invalidParameterCombinations: InvalidParameterCombination[],
  ): void {
    this.conditionPanel.initialize(invalidParameterCombinations);
  }

  onItemAspectChange(f: (aspect: string) => void): void {
    this.itemAspect.onAspectChange((aspect: string) => {
      // FIXME: in-controll rendering issue should be encapsulated in the class.
      this.itemAspect.flipSelectedAspect(aspect);
      f(aspect);
    });
  }

  enableAllCsvButtons(): void {
    // FIXME: Constructing temporary view object is a cludge; make a method
    new GraphForm().enableCsvButton($(".ranking_table_box .csv_button"));
  }
}

// Global export
window.tablemill = window.tablemill || {};
window.tablemill.CookRankingsView = CookRankingsView;

export { CookRankingsView };
